import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VersionPopupComponent } from '../components/version-popup/version-popup.component';
import { LoggingService, LogLevel } from '@app/services/logging.service';


@Injectable({
    providedIn: 'root'
})
export class PwaPromptUpdateService {
    static readonly COMPONENT_NAME = 'PwaPromptUpdateService';


    constructor(
        private updates: SwUpdate,
        private snackBar: MatSnackBar,
        private loggingService: LoggingService
    ) { }

    public init() {
        this.updates.versionUpdates.subscribe((event: any) => {
            this.loggingService.log(LogLevel.DEBUG, PwaPromptUpdateService.COMPONENT_NAME, `[PWA]: this.updates.versionUpdates event:`, event, typeof event);
            switch (event.type) {
                case 'VERSION_DETECTED':
                    this.loggingService.log(LogLevel.DEBUG, PwaPromptUpdateService.COMPONENT_NAME, '[PWA]: New version detected, downloading...', event.version?.hash);
                    break;
                case 'VERSION_READY':
                    this.loggingService.log(LogLevel.DEBUG, PwaPromptUpdateService.COMPONENT_NAME, `[PWA]: App update is ready.`);
                    this.checkIfReloadNeeded(event.latestVersion);
                    break;
                case 'VERSION_INSTALLATION_FAILED':
                    this.loggingService.log(LogLevel.ERROR, PwaPromptUpdateService.COMPONENT_NAME, '[PWA]: Failed to install app version:', event.version.hash, event.error);
                    break;
            }
        });
        this.loggingService.log(LogLevel.DEBUG, PwaPromptUpdateService.COMPONENT_NAME, `[PWA]: Initialized PwaPromptUpdateService`);
    }

    private checkIfReloadNeeded(available: { hash: string, appData: any }) {
        this.loggingService.log(LogLevel.ERROR, PwaPromptUpdateService.COMPONENT_NAME, '[PWA]: New App Version is available. data :', available);

        if (available?.appData?.forceReload) {
            this.snackBar.openFromComponent(VersionPopupComponent, {
                verticalPosition: 'top',
                horizontalPosition: 'right',
                duration: 0,
            })

        } else {
            this.loggingService.log(LogLevel.ERROR, PwaPromptUpdateService.COMPONENT_NAME, '[PWA]: Force Reload is not enabled.');
        }
    }
}
